// Paste/replace this object with any recorded session payload.
export const REPLAY_SESSION = {
    "gameId": "YOUR_OGP_GAME_ID",
    "playerId": "local-22xfwym2",
    "sessionStartTimeMs": 1770937340697,
    "seedParts": [
        "player-default",
        "1770937340697",
        "778603869898119803021200101019051919211121"
    ],
    "dtMs": 33,
    "inputsPacked": [
        -0.0924,
        0.996,
        304,
        312,
        -0.0474,
        0.999,
        317,
        318,
        -0.0309,
        1,
        318,
        319,
        0.00206,
        1,
        319,
        320,
        0.0556,
        0.998,
        320,
        321,
        0.129,
        0.992,
        321,
        322,
        0.2,
        0.98,
        322,
        323,
        0.258,
        0.966,
        323,
        324,
        0.319,
        0.948,
        324,
        325,
        0.358,
        0.934,
        325,
        326,
        0.372,
        0.928,
        326,
        327,
        0.393,
        0.92,
        327,
        328,
        0.399,
        0.917,
        328,
        329,
        0.402,
        0.915,
        329,
        333,
        -0.0974,
        0.995,
        343,
        344,
        -0.144,
        0.99,
        344,
        345,
        -0.19,
        0.982,
        345,
        346,
        -0.199,
        0.98,
        346,
        351,
        -0.194,
        0.981,
        351,
        352,
        0.176,
        0.984,
        365,
        367,
        0.181,
        0.984,
        367,
        368,
        0.203,
        0.979,
        368,
        369,
        0.252,
        0.968,
        369,
        370,
        0.286,
        0.958,
        370,
        371,
        0.303,
        0.953,
        371,
        372,
        0.311,
        0.95,
        372,
        373,
        0.32,
        0.947,
        373,
        374,
        0.324,
        0.946,
        374,
        375,
        0.331,
        0.944,
        375,
        376,
        0.331,
        0.943,
        380,
        385,
        0.311,
        0.951,
        385,
        386,
        0.1,
        0.995,
        393,
        396,
        -0.0466,
        0.999,
        396,
        397,
        -0.177,
        0.984,
        397,
        398,
        -0.181,
        0.983,
        398,
        400,
        -0.191,
        0.982,
        400,
        401,
        -0.2,
        0.98,
        401,
        403,
        -0.167,
        0.986,
        410,
        411,
        -0.153,
        0.988,
        411,
        412,
        -0.105,
        0.994,
        412,
        413,
        -0.0561,
        0.998,
        413,
        414,
        0.00242,
        1,
        414,
        415,
        0.0503,
        0.999,
        415,
        416,
        0.0694,
        0.998,
        416,
        417,
        0.0793,
        0.997,
        417,
        418,
        0.0844,
        0.996,
        418,
        419,
        0.0853,
        0.996,
        419,
        424,
        0.153,
        0.988,
        433,
        436,
        0.153,
        0.988,
        439,
        445,
        0.129,
        0.992,
        445,
        446,
        0.0857,
        0.996,
        446,
        447,
        0.0221,
        1,
        447,
        448,
        -0.0466,
        0.999,
        448,
        449,
        -0.121,
        0.993,
        449,
        450,
        -0.522,
        0.853,
        460,
        469,
        -0.035,
        0.999,
        477,
        481,
        -0.035,
        0.999,
        483,
        489,
        0.135,
        0.991,
        496,
        500,
        0.145,
        0.989,
        502,
        507,
        0.186,
        0.983,
        515,
        525,
        0.187,
        0.982,
        525,
        526,
        0.0775,
        0.997,
        532,
        537,
        -0.167,
        0.986,
        540,
        544,
        -0.307,
        0.952,
        553,
        566,
        -0.3,
        0.954,
        566,
        567,
        -0.052,
        0.999,
        576,
        578,
        0.0792,
        0.997,
        581,
        582,
        0.0846,
        0.996,
        582,
        594,
        0.0792,
        0.997,
        594,
        595,
        0.036,
        0.999,
        602,
        605,
        0.036,
        0.999,
        615,
        620,
        0.036,
        0.999,
        623,
        628,
        -0.0636,
        0.998,
        637,
        648,
        0.0244,
        1,
        656,
        664,
        0.115,
        0.993,
        672,
        681,
        0.115,
        0.993,
        687,
        691,
        0.115,
        0.993,
        698,
        709
    ],
    "clientScore": 49,
    "clientMaxAltitude": 49.42859739505895
}